export const SHARED_DIALOG_ACTION_TYPES = {
  SHOW_ATTACHMENT_DIALOG: 'SHOW_ATTACHMENT_DIALOG',
  HIDE_ATTACHMENT_DIALOG: 'HIDE_ATTACHMENT_DIALOG',
  ATTACHMENT_DIALOG_SAVED: 'ATTACHMENT_DIALOG_SAVED',
};
